import { Center, Loader } from '@mantine/core'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { homeFor } from '../components/shared/Guards'

/** `/` sends each visitor to their own area (or to sign in). */
export default function RootRedirect() {
  const status = useSelector((s) => s.auth.status)
  const user = useSelector((s) => s.auth.user)
  if (status === 'loading') {
    return (
      <Center h="60vh">
        <Loader />
      </Center>
    )
  }
  if (status === 'ready' && user) return <Navigate to={homeFor(user.role)} replace />
  return <Navigate to="/login" replace />
}
